import { parseDoc } from '../model/schema';
import type { KinklistDoc } from '../model/types';
import { ImportError } from './errors';
import { fromV2, looksLikeV2 } from './legacyV2';
import type { HydrateContext } from './wire';
import { fromWire } from './wire';

/**
 * Parses any JSON Kinklist representation and dispatches on its shape:
 * v3 wire (`{v: 3, t, r, c}`), v3 document (`{v: 3, title, ratings, …}`, e.g.
 * `kinklist.json`) or v2 data (`{username, categories, ratings}`, no `v`).
 */
export function docFromJson(text: string, ctx: HydrateContext): KinklistDoc {
  let data: unknown;
  try {
    data = JSON.parse(text);
  } catch (cause) {
    throw new ImportError('corrupt', 'Invalid JSON', { cause });
  }
  if (typeof data === 'object' && data !== null && 'v' in data) {
    if (data.v === 3 && 'c' in data) return fromWire(data, ctx);
    if (data.v === 3) {
      const doc = parseDoc(data);
      if (doc) return doc;
    }
    throw new ImportError('invalid', 'Unknown or invalid Kinklist version');
  }
  if (looksLikeV2(data)) return fromV2(data, ctx);
  throw new ImportError('invalid', 'Not Kinklist data');
}
